import React from 'react';
import { BsPlus } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Icon } from '@chakra-ui/react';

import { fieldInputTypes } from '../../../../../../../../../../../../../../constants/fieldInputTypes';
import { customPolicyPropertiesStack } from '../../../../../../../../../../../../util/customPolicyFormStacks';

import CheckboxInputRow from './CheckboxInputRow';
import LimitPropertyInputRow from './LimitPropertyInputRow';

function FieldInputGroup({ fieldInputType, useFormMethods, blueprint }) {
  const currentFieldOptions = useSelector(blueprint.selectCurrentPolicyPropertyFieldOptions);
  const currentFieldInputTypeOptions = currentFieldOptions?.[fieldInputType];
  const currentEditCustomPolicyId = useSelector(blueprint.selectCurrentEditCustomPolicyId);

  const dispatch = useDispatch();

  if (currentFieldInputTypeOptions?.length) {
    return (
      <Box mt={4}>
        {
        currentFieldInputTypeOptions.map((options, idx) => {
          switch (fieldInputType) {
            case fieldInputTypes.Checkboxes:
              return (
                <CheckboxInputRow
                  blueprint={blueprint}
                  idx={idx}
                  key={`${fieldInputType}_${idx}`}
                  options={options}
                  position="relative"
                  useFormMethods={useFormMethods}
                />
              );
            case fieldInputTypes.Monetary:
              return (
                <LimitPropertyInputRow
                  blueprint={blueprint}
                  fieldInputType={fieldInputTypes.Monetary}
                  idx={idx}
                  isEdit={currentEditCustomPolicyId?.length ?? false}
                  key={`${fieldInputType}_${idx}`}
                  options={options}
                  position="relative"
                  useFormMethods={useFormMethods}
                />
              );
            case fieldInputTypes.AlphaNumeric:
              return (
                <LimitPropertyInputRow
                  blueprint={blueprint}
                  fieldInputType={fieldInputTypes.AlphaNumeric}
                  idx={idx}
                  isEdit={currentEditCustomPolicyId?.length ?? false}
                  key={`${fieldInputType}_${idx}`}
                  options={options}
                  position="relative"
                  useFormMethods={useFormMethods}
                />
              );
            default:
              return <></>;
          }
        })
      }
        <Button
          colorScheme="brand"
          fontSize="12px"
          leftIcon={<Icon as={BsPlus} />}
          minW="113px"
          size="sm"
          textStyle="BodySm500"
          variant="textPrimary"
          onClick={() => dispatch(blueprint.updateCurrentPropertyInputOptions(
            fieldInputType,
            [...currentFieldInputTypeOptions, customPolicyPropertiesStack[fieldInputType]]
          ))}
        >
          Add Additional Option
        </Button>
      </Box>
    );
  }

  return <></>;
}

export default FieldInputGroup;
